// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__2__G2","skeleton-animation":"styles_skeleton-animation__4pUWo"};